const MAX_VOLUME = 12;

export function getGainVolume(x) {
    return Math.exp(1 - (1 / Math.pow(x, 1.01)));
}

export function getVolume(x, min, max, maxVolume=MAX_VOLUME, minVolume=-200) {
    let y = x / max;

    if (y >= 0.75) {
        let z = maxVolume * (1 - (Math.log(0.75) / Math.log(0.6)));
        z += (maxVolume - z) * (y - 0.75) / 0.25;
        return z;
    }

    let z = maxVolume * (1 - (Math.log(y) / Math.log(0.6)));
    if (isNaN(z)) {
        return minVolume;
    } else {
        return z; 
    }
}

window.q = 0.5;
window.maxVolume=6;

export function getScaledValue(x, maxVolume=window.maxVolume) {
    if (x === 0.5) {
        return 0;
    }

    let z = maxVolume * (1 - (Math.log(x) / Math.log(window.q)));
    if (z === -Infinity || isNaN(z)) {
        return -70;
    }
    return z;
}

export function getLogScale(input, minInput, maxInput, minOutput, maxOutput) {
    let y = (input - minInput) / (maxInput - minInput);
    if (y === 0) {
        return minOutput;
    }
    let z = minOutput + maxOutput * Math.pow(y, 3);
    if (isNaN(z) || z === -Infinity) {
        return minOutput;
    } else {
        return z; 
    }
}
